import { getSharedFarmSchema } from 'common/validation-schemas/farm-shared.validation-schema';

export const farmValidationSchema = () => {
  return getSharedFarmSchema();
};
